module.exports = __webpack_public_path__ + "static/media/bird-duck1.56bad61a.aac";